export const TRIP_COMPARISON_COLORS = [
  '#1f5eff',
  '#d62839',
  '#008f6a',
  '#e27a16',
  '#7651c9',
  '#0085a8',
  '#c43f91',
  '#7b5a2e',
] as const
